import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/login/Login";
import Billing from "./pages/billing/Billing";
import Navbar from "./components/navbar/Navbar";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminPage from "./pages/adminPanel/AdminPage";
import PrivateRoute from "./privateRoute/PrivateRoute";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from "./context/AuthContext";
import AuthCallback from "./pages/authCallback/AuthCallback";
import { AUTH_ROUTES } from "./utils/constants/apiRoute";
import { APP_ROUTES_PATHS } from "./utils/constants/appRoutes";
import { STORAGE_KEYS } from "./utils/constants/storageKeys";
import OfflineBanner from "./components/banners/offlineBanner";
import InstallPwaButton from "./components/pwa/InstallPwaButton";
import PrinterRegister from "./pages/printerRegister/PrinterRegister";
import RecentOrdersPage from "./pages/recentOrders/RecentOrdersPage";
import Reports from "./components/reports/Reports";
/**
 * Verifies if a user is authenticated based on token presence in localStorage.
 * @returns {boolean}
 */
const isAuthenticated = () => {
  const token = localStorage.getItem(STORAGE_KEYS.TOKEN) || sessionStorage.getItem(STORAGE_KEYS.TOKEN);
  return Boolean(token);
};

//Getting google client id
const googleClientId=process.env.REACT_APP_OAUTH_GOOGLE_CLIENT_ID;
const env_roles = JSON.parse(process.env.REACT_APP_USER_ROLES_JSON);
/**
 * The main application component that sets up routing using React Router.
 *
 * @component
 * @returns {JSX.Element} The rendered App component.
 * @author - Susovan Mishra ; susovanm@ovaku.in
 */
function App() {
  //For verifying if user is logged in or not
  const isLoggedIn = isAuthenticated();
  const role = localStorage.getItem(STORAGE_KEYS.ROLE) || sessionStorage.getItem(STORAGE_KEYS.ROLE);

  return (

    <BrowserRouter>
        <AuthProvider>
      <div className="App">
        {isLoggedIn && <Navbar />}
        <InstallPwaButton />
        <OfflineBanner />
        <Routes>
          <Route
            path={APP_ROUTES_PATHS.HOME_PATH}
            element={
              isLoggedIn
                ? role === env_roles.ADMIN
                  ? <Navigate to={APP_ROUTES_PATHS.ADMIN_PANEL_PATH} replace />
                  : <Navigate to={APP_ROUTES_PATHS.BILLING_PATH} replace />
                : <LoginPage />
            }
          />

          <Route
            path={APP_ROUTES_PATHS.BILLING_PATH}
            element={
              <PrivateRoute
                element={<Billing />}
                requiredRole={env_roles.CASHIER}
                fallbackPath={APP_ROUTES_PATHS.ADMIN_PANEL_PATH}
              />
            }
          />

          <Route
            path={APP_ROUTES_PATHS.RECENT_ORDERS_PATH}
            element={
              <PrivateRoute
                element={<RecentOrdersPage />}
                requiredRole={env_roles.CASHIER}
                fallbackPath={APP_ROUTES_PATHS.ADMIN_PANEL_PATH}
              />
            }
          />

          <Route
            path={APP_ROUTES_PATHS.ADMIN_PANEL_PATH}
            element={
              <PrivateRoute
                element={<AdminPage />}
                requiredRole={env_roles.ADMIN}
                fallbackPath={APP_ROUTES_PATHS.BILLING_PATH}
              />
            }
          />

          {/* Handle unknown routes */}
          <Route
            path="*"
            element={
              <PrivateRoute
                element={<Navigate to={APP_ROUTES_PATHS.BILLING_PATH} replace />}
                fallbackPath={APP_ROUTES_PATHS.BILLING_PATH}
              />
            }
          />

          <Route
            path={APP_ROUTES_PATHS.REPORTS_PATH}
            element={
              <PrivateRoute
                element={<Reports />}
                requiredRole={env_roles.CASHIER}
                fallbackPath={APP_ROUTES_PATHS.BILLING_PATH}
              />
            }
          />

          <Route path={APP_ROUTES_PATHS.PRINTER_REGISTER_PATH} element={<PrinterRegister />} />

          <Route path={AUTH_ROUTES.OAUTH_CALLBACK} element={<AuthCallback />} />
        </Routes>
      </div>
      <ToastContainer autoClose={900} />
      </AuthProvider>
    </BrowserRouter>
  );
}
export default App;
